<script setup>
import { ref, computed } from 'vue';
import Button from 'primevue/button';
import Card from 'primevue/card';
import Divider from 'primevue/divider';
import ProgressSpinner from 'primevue/progressspinner';
import { useToast } from 'primevue/usetoast';
import { fetchFromApi } from '@/fetch.ts';
import usagePlans from "@/config/Plans.js";

const apiUsagePlans = computed(() => {
    return usagePlans.filter(plan => plan.product_type === 'widget' && plan.price > 0);
});

const toast = useToast();

const loadingCheckout = ref(false);

async function checkout(usagePlanCode) {
    loadingCheckout.value = true;
    try {
        const response = await fetchFromApi('/widget/subscriptions/create-checkout-session?redirect_to_dash=true', 'POST', { usage_plan_code: usagePlanCode });
        if (response.error) {
            toast.add({ severity: 'error', summary: 'Error', detail: response.error, life: 5000 });
        } else {
            window.location = response.data.url
        }
    } catch (error) {
        toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
        console.error('Error during checkout:', error);
    } finally {
        loadingCheckout.value = false;
    }
}
</script>
<template>
    <div v-if="loadingCheckout">
        <Card>
            <template #title>
                Redirecting to checkout...
            </template>
            <template #content>
                <ProgressSpinner />
            </template>
        </Card>
    </div>
    <div v-else class="flex flex-row items-center flex-wrap w-full gap-2 justify-evenly">
        <Card v-for="usagePlan in apiUsagePlans" :key="usagePlan.code" class="mb-4 flex-1" style="min-width: 16rem; max-width: 16rem;">
            <template #title>
                {{ usagePlan.title }}
            </template>
            <template #content>
                
                <div class="text-2xl">${{ usagePlan.price }}</div>
                <label class="text-xs">{{ usagePlan.price_suffix }}</label>

                <Divider />
                <div class="text-sm p-1">
                    {{ usagePlan.quota }} {{ usagePlan.quota_suffix }}
                </div>                
                <div v-for="(feature, i) in usagePlan.features" :key="usagePlan.code + '_' + i" class="text-sm p-1">
                    {{ feature }}
                </div>
                <div v-for="(feature, i) in usagePlan.non_features" :key="usagePlan.code + '_' + i" class="text-sm p-1">
                    <span class="line-through">{{ feature }}</span>
                </div>
                <Divider />
                <div>
                    <Button 
                        class="mt-2" 
                        label="Subscribe" 
                        :loading="loadingCheckout"
                        :disabled="loadingCheckout"
                        @click="checkout(usagePlan.code)"
                    />
                </div>
            </template>
        </Card>
        <Card class="mb-4 flex-1" style="min-width: 16rem; max-width: 16rem; ">
            <template #content>
                <div>
                    Need a larger usage plan? Contact us:
                </div>
                <div class="my-4">
                    <a href="mailto:team@the-odds-api.com" class="underline">
                        team@the-odds-api.com
                    </a>
                </div>
            </template>
        </Card>
    </div>
    
</template>